const initSelects = () => {
  const collectionSelect = document.querySelector(`#collectionSelect_1`);
  if (!collectionSelect) return;

  console.log("collectionSelect ==== ", collectionSelect);

  // Stop polling and timeout
  clearInterval(polling);
  clearTimeout(timeout);

  // Your existing logic starts here...
  collectionSelect.value = "";
  const nestedSelect = document.querySelector(`#nestedCollectionSelect_1`);
  const productSelect = document.querySelector(`#productSelect_1`);
  const searchError = document.querySelector(`.search_field_dom.search_field_block .search_form_error`);
  const searchBtn = document.querySelector(`.search_field_dom.search_field_block .search_btn`);

  const collectionSelectize = $(collectionSelect).selectize({
    placeholder: 'Select Brand',
    allowEmptyOption: false,
    closeAfterSelect: true,
    onChange(value) {
      nestedSelectize.clearOptions();
      nestedSelectize.clear(true);
      nestedSelectize.setValue("");

      productSelectize.clearOptions();
      productSelectize.clear(true);
      productSelectize.setValue("");

      searchError.innerHTML = '';
      if (!value) return;
      fetchNestedOptions(value);
    }
  })[0].selectize;

  const nestedSelectize = $(nestedSelect).selectize({
    placeholder: 'Select Type',
    allowEmptyOption: false,
    closeAfterSelect: true,
    onChange(value) {
      productSelectize.clearOptions();
      productSelectize.clear(true);
      productSelectize.setValue("");

      searchError.innerHTML = '';
      if (!value) return;
      fetchProductOptions(value);
    }
  })[0].selectize;

  const productSelectize = $(productSelect).selectize({
    placeholder: 'Select Model',
    allowEmptyOption: false,
    closeAfterSelect: true,
    onChange(value) {
      searchError.innerHTML = '';
    }
  })[0].selectize;

  // Mobile step-by-step field visibility for <=767px
let initialSetupDone = false;

function handleFieldProgression() {
  const isMobile = window.innerWidth <= 767;

  if (!isMobile) {
    // Show all fields and search button on desktop
    document.querySelectorAll('.search_field_col').forEach(el => el.classList.add('visible'));
    searchBtn.classList.add('visible');
    return;
  }

  // Prevent re-hiding fields on resize after initial setup
  if (!initialSetupDone) {
    // Hide all fields and button initially
    document.querySelectorAll('.search_field_col').forEach(el => el.classList.remove('visible'));
    searchBtn.classList.remove('visible');

    // Only show the first (Brand) field
    document.querySelector('.field_1')?.closest('.search_field_col')?.classList.add('visible');

    initialSetupDone = true;
  }

  // Keep showing next fields if value already selected (useful on resize or revisit)
  if (collectionSelectize.getValue()) {
    document.querySelector('.field_2')?.closest('.search_field_col')?.classList.add('visible');
  }

  if (nestedSelectize.getValue()) {
    document.querySelector('.field_3')?.closest('.search_field_col')?.classList.add('visible');
    searchBtn.classList.add('visible');
  }

  // Listen to changes
  collectionSelectize.on('change', (value) => {
    if (value) {
      document.querySelector('.field_2')?.closest('.search_field_col')?.classList.add('visible');
    }
  });

  nestedSelectize.on('change', (value) => {
    if (value) {
      // const modelField = document.querySelector('.field_3')?.closest('.search_field_col');
      // modelField?.classList.add('visible');
      searchBtn.classList.add('visible');
    }
  });
}

// Run initially
handleFieldProgression();

// On screen resize, recheck only visibility without hiding
window.addEventListener('resize', () => {
  if (window.innerWidth > 767) {
    document.querySelectorAll('.search_field_col').forEach(el => el.classList.add('visible'));
    searchBtn.classList.add('visible');
  } else {
    // Just re-run visibility logic, no hiding
    handleFieldProgression();
  }
});


  async function fetchNestedOptions(collectionHandle) {
    nestedSelectize.clearOptions();
    nestedSelectize.clear(true);
    nestedSelectize.setValue("");

    productSelectize.clearOptions();
    productSelectize.clear(true);
    productSelectize.setValue("");

    searchError.innerHTML = '';

    if (!collectionHandle) return;

    const url = `https://www.danseusa.com/collections/${collectionHandle}?view=collection_ajex`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const html = (await response.text()).trim();

      if (html == "") {
        searchError.innerHTML = "Selected Brand Does Not Have Any Collections.";
       
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const nestedItems = tempDiv.querySelectorAll('p[data-href][data-collection-title]');
      nestedItems.forEach(p => {
        const href = p.getAttribute('data-href');
        const title = p.getAttribute('data-collection-title');
        const handle = href.split('/').pop();
        nestedSelectize.addOption({ value: handle, text: title });
      });
      nestedSelectize.refreshOptions(false);
    } catch (error) {
      searchError.innerHTML = error.message || "Error loading Type options.";
      console.error('Fetch error (Type):', error);
    }
  }

  async function fetchProductOptions(collectionHandle) {
    productSelectize.clearOptions();
    productSelectize.clear(true);
    productSelectize.setValue("");

    searchError.innerHTML = '';

    if (!collectionHandle) return;

    const url = `https://www.danseusa.com/collections/${collectionHandle}?view=collection_ajex`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const html = (await response.text()).trim();

      if (html == "") {
        searchError.innerHTML = "Selected Collection Does Not Have Any Products.";
        // const popup = document.getElementById('noResultPopup');
        // popup?.classList.remove('hidden');
        // alert("nested");

        document.querySelector('.field_3')?.closest('.search_field_col')?.classList.remove('visible');
        return;
      }else{
        document.querySelector('.field_3')?.closest('.search_field_col')?.classList.add('visible');
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const productItems = tempDiv.querySelectorAll('p[data-href][data-collection-title]');
      productItems.forEach(p => {
        const href = p.getAttribute('data-href');
        const title = p.getAttribute('data-collection-title');
        const handle = href.split('/').pop();
        productSelectize.addOption({ value: handle, text: title });
      });
      productSelectize.refreshOptions(false);
    } catch (error) {
      searchError.innerHTML = error.message || "Error loading Model options.";
      console.error('Fetch error (Model):', error);
    }
  }

  // searchBtn.addEventListener('click', () => {
    
  //   const selectedValue = productSelectize.getValue();
  //   if (!selectedValue) return;

  //   const params = new URLSearchParams();
  //   params.set("searchBreadcrumb", "1");
  //     // Show loader
  //   searchBtn.querySelector('.btn-text').classList.add('hidden');
  //   searchBtn.querySelector('.btn-loader').classList.remove('hidden');
  //   searchBtn.setAttribute('disabled', true);

  //   // code for breadcrumb
  //   const brandEl = document.querySelector('#collectionSelect_1 + .selectize-control .item');
  //   const typeEl = document.querySelector('#nestedCollectionSelect_1 + .selectize-control .item');
  //   const modelEl = document.querySelector('#productSelect_1 + .selectize-control .item');

  //   if (!brandEl || !typeEl || !modelEl) {
  //     console.warn("⚠️ Missing selection in dropdowns.");
  //     return;
  //   }

  //   const breadcrumbArray = [
  //     {
  //       collection_handle: brandEl.dataset.value,
  //       collection_title: brandEl.textContent.trim()
  //     },
  //     {
  //       collection_handle: typeEl.dataset.value,
  //       collection_title: typeEl.textContent.trim()
  //     },
  //     {
  //       collection_handle: modelEl.dataset.value,
  //       collection_title: modelEl.textContent.trim()
  //     }
  //   ];

  //   setCookie("collectionData", JSON.stringify(breadcrumbArray), 7);
  //   window.collectionData = breadcrumbArray;
    
      
  //   window.location.href = `/collections/${selectedValue}`;
  // });

  searchBtn.addEventListener('click', () => {

  let selectedValue = '';
  let breadcrumbArray = [];

  const brandEl = document.querySelector('#collectionSelect_1 + .selectize-control .item');
  const typeEl = document.querySelector('#nestedCollectionSelect_1 + .selectize-control .item');
  const modelEl = document.querySelector('#productSelect_1 + .selectize-control .item');

  // PRIORITY 1: product
  if (productSelectize.getValue()) {
    selectedValue = productSelectize.getValue();

    // breadcrumb (3 levels)
    breadcrumbArray = [
      {
        collection_handle: brandEl.dataset.value,
        collection_title: brandEl.textContent.trim()
      },
      {
        collection_handle: typeEl.dataset.value,
        collection_title: typeEl.textContent.trim()
      },
      {
        collection_handle: modelEl.dataset.value,
        collection_title: modelEl.textContent.trim()
      }
    ];
  }
  // PRIORITY 2: nested
  else if (nestedSelectize.getValue()) {
    selectedValue = nestedSelectize.getValue();

    // breadcrumb (2 levels)
    breadcrumbArray = [
      {
        collection_handle: brandEl.dataset.value,
        collection_title: brandEl.textContent.trim()
      },
      {
        collection_handle: typeEl.dataset.value,
        collection_title: typeEl.textContent.trim()
      }
    ];
  }

  if (!selectedValue) return;

  // Loader
  searchBtn.querySelector('.btn-text').classList.add('hidden');
  searchBtn.querySelector('.btn-loader').classList.remove('hidden');
  searchBtn.setAttribute('disabled', true);

  // Save cookie
  setCookie("collectionData", JSON.stringify(breadcrumbArray), 7);
  window.collectionData = breadcrumbArray;

  // Redirect
  window.location.href = `/collections/${selectedValue}`;
});

  function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/;";
    }
};


// // Close popup
document.addEventListener('click', function (e) {
  if (e.target.classList.contains('close-popup')) {
    document.getElementById('noResultPopup')?.classList.add('hidden');
  }
});


// Start polling every 100ms
const polling = setInterval(initSelects, 100);

// Stop polling after 30 seconds if element not found
const timeout = setTimeout(() => {
  clearInterval(polling);
  console.warn('Polling stopped after 30 seconds — #collectionSelect_1 not found.');
}, 20000);
